// URL publique du workbook Reset Éclora.
// Pour remplacer le PDF plus tard : modifier uniquement cette valeur
// (et PDF_URL dans backend/.env pour le lien envoyé par email).
export const WORKBOOK_URL = '/reset-eclora.pdf';
